import React from 'react';
import { Hero } from './components/Hero';
import { WhyNow } from './components/WhyNow';
import { InsideGuide } from './components/InsideGuide';
import { HowItWorks } from './components/HowItWorks';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-cream-100 font-sans text-ink-900 selection:bg-olive-200 selection:text-ink-900" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <WhyNow data-id="element-3" />
        <InsideGuide data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <Benefits data-id="element-6" />
        <Bonuses data-id="element-7" />
        <Testimonials data-id="element-8" />
        <FAQ data-id="element-9" />
        <FinalOffer data-id="element-10" />
      </main>

      <StickyCTA data-id="element-11" />

      <footer className="bg-cream-200 text-ink-600 py-10 pb-28 md:pb-10 px-5 text-center text-xs md:text-sm" data-id="element-12">
        <div className="max-w-3xl mx-auto space-y-3" data-id="element-13">
          <p className="font-serif text-base text-ink-800 italic" data-id="element-14">
            Más de 300 Remedios Naturales de la Abuela
          </p>
          <p className="leading-relaxed" data-id="element-15">
            Esta guía es material educativo e informativo. No reemplaza el
            consejo, diagnóstico ni tratamiento de un profesional de la salud.
            Ante cualquier síntoma persistente, consultá con un médico.
          </p>
          <p className="pt-3" data-id="element-16">
            © {new Date().getFullYear()} · Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}